import { createAsyncThunk } from '@reduxjs/toolkit';
import { Shape } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { CreatePatchShape, FindShape, GetShape } from './interface';

export const createShape = createAsyncThunk(
  'shape/createShape',
  async (values: CreatePatchShape, { rejectWithValue }) => {
    try {
      const response = await Shape.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const findShape = createAsyncThunk('shape/findShape', async (values: FindShape, { rejectWithValue }) => {
  try {
    const response = await Shape.find({
      query: values,
    });

    return response;
  } catch (error: any) {
    toastHandler(error);
    return rejectWithValue(error.message);
  }
});

export const getShape = createAsyncThunk(
  'shape/getShape',
  async ({ id }: GetShape, { rejectWithValue }) => {
    try {
      const response = await Shape.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchShape = createAsyncThunk(
  'shape/patchShape',
  async ({ id, ...values }: CreatePatchShape, { rejectWithValue }) => {
    try {
      const response = await Shape.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
